import { Component, OnInit } from '@angular/core';
import { InventoryService } from '../../../agatextscreens/inventory/inventory.service';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-select-similar-piece',
  templateUrl: './select-similar-piece.component.html',
  styleUrls: ['./select-similar-piece.component.scss']
})
export class SelectSimilarPieceComponent implements OnInit {
  products: any[] = [];
  pieceNumber: string;
  branch_code: string;
  alsoInList: any[] = [];

  constructor(private _inventoryService: InventoryService,
    private _dialogRef: MdDialogRef<SelectSimilarPieceComponent>) { }

  ngOnInit() {
    this.findItem();
  }

  findItem(): void {
    this._inventoryService.findSimilar(this.pieceNumber).subscribe(
      response => {
        this.products = response;
        this.filter();
      }
    );
  }

  filter() {
    this.products = this.products.filter(p => { return p.branch_code == this.branch_code });
    this.products.forEach(
      p => {
        if (this.alsoInList.some(i => { return p['piece_number'] == i['piece_number'] })) {
          p['disabled'] = true;
        }
      }
    );
  }

  choose(product: any) {
    // Only allow choosing if the piece is not pat of this order
    if (!product['disabled'] && !product['defect'])  this._dialogRef.close(product);
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/select-similar-piece/select-similar-piece.component.ts